import { render, staticRenderFns } from "./claimFormExam.vue?vue&type=template&id=76960040&scoped=true&"
import script from "./claimFormExam.vue?vue&type=script&lang=js&"
export * from "./claimFormExam.vue?vue&type=script&lang=js&"
import style0 from "./claimFormExam.vue?vue&type=style&index=0&id=76960040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76960040",
  null
  
)

export default component.exports